import { useEffect, useMemo, useRef, useState } from 'react';
import { getSessionEmpresaId, isSessionSuperAdmin } from '../../../../../utils/SessionUser';


const EMPTY_FORM = {
    nombre: '',
    idPadre: '',
    activo: true,
};

export default function EmpresasModal({
    open,
    mode = 'new',
    data = null,
    onClose,
    onSubmit,
    loading = false,
    inline = false,
    parentOptions = [],
}) {
    const [form, setForm] = useState(EMPTY_FORM);
    const [errors, setErrors] = useState({ nombre: '' });
    const nameInputRef = useRef(null);

    const userEmpresaId = getSessionEmpresaId();
    const isSuperAdmin = isSessionSuperAdmin();


    useEffect(() => {
        if (!open) return;
        if (mode === 'edit' && data) {
            setForm({
                idEmpresa: data.idEmpresa ?? 0,
                nombre: data.nombre ?? '',
                idPadre: (data.idPadre !== null && data.idPadre !== undefined) ? String(data.idPadre) : '',
                activo: data.activo ?? true,
            });
        } else {
            setForm({
                ...EMPTY_FORM,
                idPadre: !isSuperAdmin ? String(userEmpresaId) : '',
            });
            setErrors({ nombre: '' });
        }
    }, [open, mode, data, isSuperAdmin, userEmpresaId]);


    const validateField = (field, value) => {
        let error = '';
        if (field === 'nombre' && !value?.trim()) {
            error = 'El nombre es obligatorio.';
        }
        setErrors((prev) => ({ ...prev, [field]: error }));
        return !error;
    };

    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
        if (field === 'nombre') validateField('nombre', value);
    };

    const handleSubmit = () => {
        if (!validateField('nombre', form.nombre)) return;

        // Mapeo PascalCase para asegurar compatibilidad total con C# DTO
        const payload = {
            Nombre: form.nombre,
            IdPadre: (form.idPadre === '' || form.idPadre == null) ? null : parseInt(form.idPadre, 10),
            Activo: form.activo
        };

        console.log('DEBUG EMPRESAS - Enviando desde Modal:', payload);
        onSubmit?.(payload, mode);
    };

    if (!open) return null;

    const Header = (
        <div className="roles-topbar" style={{ paddingRight: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flex: '0 0 auto' }}>
            <h3 className="roles-title">
                {mode === 'new' ? 'Nueva Empresa' : 'Editar Empresa'}
            </h3>
            <button className="roles-btn" onClick={onClose}>✕</button>
        </div>
    );

    const Body = (
        <div style={{ padding: '0 16px 16px 16px', display: 'grid', gridTemplateColumns: '1fr', gap: '1rem', overflowY: 'auto', flex: '1 1 auto' }}>
            <div>
                <label className="roles-title" style={{ fontSize: '.9rem' }}>Nombre de la Empresa *</label>
                <input
                    type="text"
                    className={`infoField ${errors.nombre ? 'infoField--error' : ''}`}
                    ref={nameInputRef}
                    value={form.nombre}
                    onChange={(e) => handleChange('nombre', e.target.value)}
                    style={{ width: '100%', marginTop: '0.5rem' }}
                />
                {errors.nombre && (
                    <small style={{ color: '#b91c1c' }}>{errors.nombre}</small>
                )}
            </div>

            {/* Solo SuperAdmin elige la empresa padre. Para cualquier otro usuario
                el idPadre viene implícito de su sesión y nunca se expone en la UI. */}
            {isSuperAdmin && (
                <div>
                    <label className="roles-title" style={{ fontSize: '.9rem' }}>Empresa Padre</label>
                    <select
                        className="infoField"
                        value={form.idPadre}
                        onChange={(e) => handleChange('idPadre', e.target.value)}
                        style={{ width: '100%', marginTop: '0.5rem' }}
                    >
                        <option value="">— Sin empresa padre (raíz) —</option>
                        {parentOptions
                            .filter(e => e.idEmpresa !== form.idEmpresa)
                            .map(e => (
                                <option key={e.idEmpresa} value={e.idEmpresa}>
                                    {e.nombre}
                                </option>
                            ))
                        }
                    </select>
                </div>
            )}
        </div>
    );

    const Footer = (
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '.6rem', padding: '16px', flex: '0 0 auto' }}>
            <button className="roles-btn" onClick={onClose}>Cancelar</button>
            <button className="btn-action" onClick={handleSubmit} disabled={loading}>
                {loading ? 'Guardando...' : (mode === 'new' ? 'Guardar' : 'Actualizar')}
            </button>
        </div>
    );

    if (inline) {
        return (
            <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                {Header}
                {Body}
                {Footer}
            </div>
        );
    }

    return (
        <div className="roles-confirm-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
            <div className="roles-confirm-card" style={{ width: 'min(600px, 95vw)', maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
                {Header}
                {Body}
                {Footer}
            </div>
        </div>
    );
}
